import ExpandMoreIcon from "@mui/icons-material//ExpandMore"
import { AccordionSummary, Typography } from '@mui/material'
import { getClient } from "../functions"

export default function FilterTitle({ cliente, dataInicio, dataFim }) {

    const getFilterTitle = (cliente, dataInicio, dataFim) => {
        let strAcordion = 'Filtros'

        if (getClient(cliente)) {
            let nomeCliente = (
                cliente && cliente.length && cliente.length > 1
                    ? `${cliente[0].nome} e mais ${cliente.length - 1} ${cliente.length === 2 ? 'cliente' : 'clientes'}`
                    : getClient(cliente).nome
            )
            strAcordion = nomeCliente + " - "
            strAcordion += dataInicio.split("-").reverse().join("/") + " até " + dataFim.split("-").reverse().join("/")
        }

        return strAcordion
    }
    return (
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography color="text.secondary">{getFilterTitle(cliente, dataInicio, dataFim)}</Typography>
        </AccordionSummary>
    )
}